'use client';
const OpenFilterButton = ({ params }) => {
  const handleClick = e => {
    e.preventDefault();

    document.dispatchEvent(new CustomEvent('open-filter'));
  };

  return (
    <button
      type={'text'}
      className={'border border-black bg-white text-black px-4 py-3 '}
      onClick={handleClick}
    >
      Filter
    </button>
  );
};

export default OpenFilterButton;
